import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import useHttpHook from "../../../../Hooks/HttpHook";
import { updCartData } from "../../../../ReduxSlice/Checkout/cartSlice";
import {
  GetAddonsApi,
  GetCart,
  GetInstallmentsByEvent,
  GetUserCards,
  PlaceOrder,
  UserEventById,
} from "../../../../utils/ApiConstant";
import { OrderLanguage } from "../../../../utils/Languages";
import MainComponentWrapper from "../../../Common/MainComponentWrapper";
import Input from "../../../UiElement/FormElement/Input";
import CheckoutForm from "./CheckoutForm";
import OrderSummamry from "./OrderSummary";
import { toast } from "react-toastify";
import { updEventData } from "../../../../ReduxSlice/Event/eventSlice";
import AddonsList from "../../../../Pages/Organizer/EventMgt/AddonsList";
import { showErrorToast } from "../../../../utils/notify";

const Checkout = (props) => {
  const dispatch = useDispatch();
  const params = useParams();
  const { eventId } = params;
  const navigate = useNavigate();
  const [loading, sendRequest, error] = useHttpHook();
  const [installment, setInstallment] = useState(null);
  const [selectedEmi, setSelectedEmi] = useState(null);
  const [selectedAddons, setSelectedAddons] = useState([]);

  const cart = useSelector((state) => state.cart);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [cards, setCards] = useState([]);
  const [selectedCard, setSelectedCard] = useState(null);

  const [paymentType, setPaymentType] = useState("card");
  const query = new URLSearchParams(window.location.search);
  const referralId = query.get("referralId");
  const { userDetails } = useSelector((state) => state.user);
  const EventData = useSelector((state) => state.event.data);

  const eventCreatorId =
    EventData?.createdBy?._id ||
    EventData?.createdBy ||
    cart?.data?.eventId?.createdBy?._id ||
    cart?.data?.eventId?.createdBy;
  const loadedEventId = EventData?._id || EventData?.id;
  const checkoutEventId = props.eventId || eventId;
  const eventDataMatchesCheckout =
    !loadedEventId ||
    String(loadedEventId) === String(checkoutEventId);
  const isEventOwner =
    eventDataMatchesCheckout &&
    !!userDetails?._id &&
    !!eventCreatorId &&
    String(userDetails._id) === String(eventCreatorId);
  const canUseCash = isEventOwner;
  const canUseFree =
    isEventOwner && userDetails?.userType === "organizer";
  const isSplitPaymentEnabled = Boolean(
    EventData?.settings?.settings?.splitPaymentEnabled
  );
  const minSplitOrderAmount = Number(
    EventData?.settings?.settings?.minSplitOrderAmount || 0
  );
  const cartTotal = Number(cart?.data?.total || 0);
  const canUseSplitPayment =
    isSplitPaymentEnabled &&
    installment?.installments?.length > 0 &&
    cartTotal >= minSplitOrderAmount;
  const isDailySplit = installment?.interval === "day";
  const splitUnitShort = isDailySplit ? "D" : "M";

  useEffect(() => {
    if (
      (paymentType === "cash" && !canUseCash) ||
      (paymentType === "free" && !canUseFree)
    ) {
      setPaymentType("card");
    }
  }, [paymentType, canUseCash, canUseFree]);

  useEffect(() => {
    if (paymentType === "emi" && (!isSplitPaymentEnabled || !canUseSplitPayment)) {
      if (!isSplitPaymentEnabled) {
        setPaymentType("card");
        setSelectedEmi(null);
      }
    }
  }, [paymentType, isSplitPaymentEnabled, canUseSplitPayment]);

  const getEmiInstallments = async () => {
    const response = await sendRequest(GetInstallmentsByEvent + props.eventId, {
      method: "get",
    });

    if (response.status === 1) {
      setInstallment(response.data);
    }
  };
  useEffect(() => {
    if (!EventData?._id || String(EventData._id) !== String(props.eventId)) {
      getEventData(props.eventId);
    }
    if (cart.status === false) {
      getCartData();
    }
    getUserCards();
    getEmiInstallments();
  }, []);

  useEffect(() => {
    if (cart?.data?.total) {
      getEmiInstallments();
    }
  }, [cart?.data?.total]);

  useEffect(() => {
    if (error) {
      if (toast.isActive(error) === false) {
        showErrorToast(error);
        if (error === "You are unAuthrised") {
          window.location.href = `${process.env.REACT_APP_MERCH_URL}/login`;
        }
      }
    }
  }, [error]);

  const getCartData = async () => {
    let cartData = await sendRequest(GetCart + props.eventId, {
      method: "get",
    });
    if (cartData.status === 1) {
      dispatch(updCartData(cartData));
    }
  };

  const getEventData = async (eventId) => {
    let event = await sendRequest(UserEventById + eventId, { method: "get" });
    dispatch(updEventData(event));
  };
  const getUserCards = async () => {
    try {
      const res = await sendRequest(GetUserCards, {
        method: "get",
      });
      setCards(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const submitForm = async (data) => {
    try {
      if (paymentType === "emi" && !selectedEmi) {
        toast.error("Please select a split payment plan");
        return;
      }
      let obj = {};
      if (selectedCard) {
        obj = {
          ...data,
          selectedAddons,
          card: selectedCard,
          requestOrigin: "web",
          paymentType: paymentType,
          emiInstallments: selectedEmi,
        };
      } else {
        obj = {
          ...data,
          selectedAddons,
          card: {
            name: data.name,
            cardNumber: data.cardNumber,
            expiryMonth: data.expiryMonth,
            cvv: data.cvv,
            expiryYear: data.expiryYear,
          },
          paymentType: paymentType,
          requestOrigin: "web",
          emiInstallments: selectedEmi,
        };
      }
      const a = ["null", null, undefined, "undefined"];

      const res = await sendRequest(
        `${PlaceOrder}/${eventId}?referralId=${
          !a.includes(referralId) ? referralId : ""
        }`,
        {
          method: "post",
          data: obj,
        }
      );

      if (res.status === 1) {
        localStorage.removeItem("referralId");
        const orderId = res?.data?._id || res?.data || "";
        const query = new URLSearchParams({ eventId: String(eventId) });
        if (orderId) {
          query.set("orderId", String(orderId));
        }
        navigate(`/checkout/success?${query.toString()}`);
      }
      if (res.status === 4) {
        showErrorToast(res?.message);
        navigate(`/purchase-tickets/${eventId}`);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const [addons, setAddons] = useState([]);
  const [addonLoading, setAddonLoading] = useState(false);
  const getAddons = async () => {
    try {
      setAddonLoading(true);
      const response = await sendRequest(GetAddonsApi + eventId);
      if (response.status === 1) {
        setAddons(response.data);
      }
    } catch (error) {
      console.log(error);
      setAddonLoading(false);
    } finally {
      setAddonLoading(false);
    }
  };

  useEffect(() => {
    if (eventId) {
      getEventData(eventId);
      getAddons();
    }
  }, [eventId]);
  console.log(selectedAddons, "--------- selected addons");
  return (
    <MainComponentWrapper Loading={loading} errorInfo={error}>
      <div className="event-checkout-body">
        <form className="row g-4 g-xl-5" onSubmit={handleSubmit(submitForm)}>
          <div className="col-lg-8">
            <div className="event-checkout-form">
              <section className="event-checkout-section">
                <h2 className="event-checkout-section-title">
                  {OrderLanguage.CheckoutForm.contactInfo.heading}
                </h2>
                <div className="event-checkout-fields-grid">
                  <Input
                    element="text"
                    CustomFormGroupCls="event-checkout-field"
                    InputClassName="event-checkout-input"
                    Label={
                      OrderLanguage.CheckoutForm.contactInfo.form.firstName
                        .label
                    }
                    ValidationArr={[{ Type: "required" }]}
                    FieldName="firstName"
                    Register={register}
                    Errors={errors}
                  />
                  <Input
                    element="text"
                    CustomFormGroupCls="event-checkout-field"
                    InputClassName="event-checkout-input"
                    Label={
                      OrderLanguage.CheckoutForm.contactInfo.form.lastName.label
                    }
                    ValidationArr={[{ Type: "required" }]}
                    FieldName="lastName"
                    Register={register}
                    Errors={errors}
                  />
                  <Input
                    element="text"
                    CustomFormGroupCls="event-checkout-field"
                    InputClassName="event-checkout-input"
                    Label={
                      OrderLanguage.CheckoutForm.contactInfo.form.email.label
                    }
                    ValidationArr={[{ Type: "required" }]}
                    FieldName="email"
                    Register={register}
                    Errors={errors}
                  />
                  <Input
                    element="text"
                    CustomFormGroupCls="event-checkout-field"
                    InputClassName="event-checkout-input"
                    Label={
                      OrderLanguage.CheckoutForm.contactInfo.form.confirmEmail
                        .label
                    }
                    ValidationArr={[{ Type: "required" }]}
                    FieldName="confirmEmail"
                    Register={register}
                    Errors={errors}
                  />
                </div>
              </section>

              <section className="event-checkout-section">
                <h2 className="event-checkout-section-title">
                  {OrderLanguage.CheckoutForm.paymentMethod.heading}
                </h2>

                <div className="event-checkout-pay-types">
                  <label
                    className={`event-checkout-pay-type${
                      paymentType === "card" ? " is-selected" : ""
                    }`}
                  >
                    <input
                      type="radio"
                      name="paymentType"
                      value="card"
                      checked={paymentType === "card"}
                      onChange={(e) => {
                        setPaymentType(e.target.value);
                        setSelectedEmi(null);
                      }}
                    />
                    Card
                  </label>

                  {isSplitPaymentEnabled && (
                    <label
                      className={`event-checkout-pay-type${
                        paymentType === "emi" ? " is-selected" : ""
                      }`}
                    >
                      <input
                        type="radio"
                        name="paymentType"
                        value="emi"
                        checked={paymentType === "emi"}
                        onChange={(e) => setPaymentType(e.target.value)}
                      />
                      Split Payment
                    </label>
                  )}

                  {canUseCash && (
                    <label
                      className={`event-checkout-pay-type${
                        paymentType === "cash" ? " is-selected" : ""
                      }`}
                    >
                      <input
                        type="radio"
                        name="paymentType"
                        value="cash"
                        checked={paymentType === "cash"}
                        onChange={(e) => {
                          setPaymentType(e.target.value);
                          setSelectedEmi(null);
                        }}
                      />
                      Cash
                    </label>
                  )}

                  {canUseFree && (
                    <label
                      className={`event-checkout-pay-type${
                        paymentType === "free" ? " is-selected" : ""
                      }`}
                    >
                      <input
                        type="radio"
                        name="paymentType"
                        value="free"
                        checked={paymentType === "free"}
                        onChange={(e) => {
                          setPaymentType(e.target.value);
                          setSelectedEmi(null);
                        }}
                      />
                      Free
                    </label>
                  )}
                </div>

                {paymentType === "emi" && (
                  <div className="event-checkout-split-list">
                    {installment?.installments?.length > 0 ? (
                      installment.installments.map((item, index) => (
                        <label
                          key={index}
                          className={`event-checkout-split-option${
                            selectedEmi === item?.months ? " is-selected" : ""
                          }`}
                        >
                          <span className="event-checkout-split-copy">
                            USD <strong>{item?.amount}</strong> X{" "}
                            {item?.months} {splitUnitShort}
                          </span>
                          <input
                            type="radio"
                            name="emi"
                            value={item?.months}
                            checked={selectedEmi === item?.months}
                            onChange={(e) =>
                              setSelectedEmi(Number(e.target.value))
                            }
                          />
                        </label>
                      ))
                    ) : (
                      <p className="event-checkout-split-unavailable">
                        {installment?.reason === "min_amount" ||
                        cartTotal < minSplitOrderAmount
                          ? `Minimum order amount for Split Payment is USD ${minSplitOrderAmount}.`
                          : installment?.reason === "too_soon"
                          ? `Split payment is not available because the event starts too soon for ${
                              isDailySplit ? "daily" : "monthly"
                            } installments.`
                          : "No split payment plans available for this order."}
                      </p>
                    )}
                  </div>
                )}

                {(paymentType === "card" || paymentType === "emi") && (
                  <div className="event-checkout-payment-panels">
                    <div className="event-checkout-panel event-checkout-cards-panel">
                      <CheckoutForm
                        setCard={setSelectedCard}
                        cardList={cards}
                        register={register}
                        getUserCards={getUserCards}
                        errors={errors}
                        selectedCard={selectedCard}
                      />
                    </div>
                  </div>
                )}

                {paymentType === "cash" && (
                  <div className="event-checkout-payment-panels">
                    <div className="event-checkout-panel event-checkout-cash-panel">
                      <Input
                        element="text"
                        CustomFormGroupCls="event-checkout-field"
                        InputClassName="event-checkout-input"
                        Label="Amount"
                        ValidationArr={[{ Type: "required" }]}
                        FieldName="amount"
                        Register={register}
                        Errors={errors}
                      />
                    </div>
                  </div>
                )}
              </section>
            </div>
          </div>

          <div className="col-lg-4">
            <OrderSummamry
              navigateLink="/success/"
              eventId={props.eventId}
              cart={cart.data}
              mainimage={cart.data.mainimage}
              title={cart.data.title}
              getCartData={getCartData}
              getEmiInstallments={getEmiInstallments}
              installment={installment}
              isFree={paymentType === "free"}
              isLoading={loading}
              paymentType={paymentType}
              isShowSplitPayment={isSplitPaymentEnabled}
              minSplitOrderAmount={minSplitOrderAmount}
              onProceed={handleSubmit(submitForm)}
            />
          </div>
        </form>
      </div>
    </MainComponentWrapper>
  );
};

export default Checkout;
